const parametrizationRevisionHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: true
      }
    ]
  },
  {
    group: '  ',
    columns: [
      {
        name: 'Solicitante',
        id: 'solicitacao-solicitante',
        show: true
      },
      {
        name: 'Data',
        id: 'solicitacao-data',
        show: true
      }
    ]
  },
  {
    group: 'Valor',
    columns: [
      {
        name: 'Antigo',
        id: 'valor-antigo',
        show: true
      },
      {
        name: 'Novo',
        id: 'valor-novo',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código',
        id: 'produto-codigo',
        show: false
      },
      {
        name: 'Descrição',
        id: 'produto-descricao',
        show: true
      }
    ]
  },
  {
    group: 'Loja',
    columns: [
      {
        name: 'Código',
        id: 'loja-codigo',
        show: true
      },
      {
        name: 'Descrição',
        id: 'loja-descricao',
        show: false
      }
    ]
  },
  {
    group: 'Aprovação',
    columns: [
      {
        name: 'Nome',
        id: 'aprovacao-nome',
        show: true
      },
      {
        name: 'Data',
        id: 'aprovacao-data',
        show: true
      },
      {
        name: 'Status',
        id: 'aprovacao-status',
        show: true
      }
    ]
  }
]

export default parametrizationRevisionHeader
